(function() {
function updateItem(data) {
    fetch("/cart/change.json", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
        },
        body: JSON.stringify(data)
    }).then(function (cart) {
      	cart.json().then(function (content) {
			updateCartPage(content);
        })
     })
}

function updateItemById(lineItemId, newQuantity, newProperties = {}) {
    return updateItem({
        id: lineItemId,
        quantity: newQuantity,
        properties: newProperties
    });
}

function updateCartPage(content) {
	var cartTotal = content.total_price;
  	var $cartTotal = document.querySelector('.cart__subtotal');
  	$cartTotal.innerHTML = wetheme.formatMoney(cartTotal);


  	 content.items.forEach(function(item, index){
      	var $itemQty = document.querySelector('#updates_'+ item.id);
		var itemQty = item.quantity;
      	$itemQty.value = itemQty;

      	var $itemTotalPrice = document.querySelector('#line-total-'+ item.id);
        $itemTotalPrice.innerHTML = wetheme.formatMoney(item.final_line_price);

    });
}

var $qtyInputs = document.querySelectorAll('[name="updates[]"]');

$qtyInputs.forEach(function (input){
  input.addEventListener('change', function (evt){
    var newQty = this.value;
	var varaintId = this.getAttribute('id').split('_')[1];
	var newCartItems = updateItemById(varaintId, newQty);
    evt.preventDefault();
    return false
  })
})

document.addEventListener('variant:changed', function(event) {
 const variant = event.detail.variant; // Gives you access to the whole variant details
 if (typeof window.color_option !== "undefined") {
   UpdateProductGallery(variant[window.color_option])
 }
  
  onVariantChangedOrLoaded(variant);
});

document.addEventListener('variant:initial:loaded', function(event) {
 const variant = event.detail.variant; // Gives you access to the whole variant details
 if (typeof window.currentSelectedColor !== "undefined") {
   UpdateProductGallery(window.currentSelectedColor)
 }
  
  onVariantChangedOrLoaded(variant);
});
  
function onVariantChangedOrLoaded(variant) {
  document.querySelectorAll('input[name="option-2"]').forEach((colorSwatch) => {
    if (colorSwatch.value === variant.option2) {
    	colorSwatch.click();
    }      
  });
  
  document.querySelectorAll('input[name="option-1"]').forEach((sizeButton) => {
    if (sizeButton.value === variant.option1) {
    	sizeButton.click();
    }      
  });
}

function UpdateProductGallery(color) {
  var productThumbnails = document.querySelectorAll('.product-medias__thumbnails a');
  var productWrapper = productThumbnails[0].closest('.product-single-wrapper');
  
  if (!productWrapper) {
  	return;  
  }
  
  productThumbnails.forEach(function(thumb){
    var mediaId = thumb.getAttribute('data-media-id');
    var gallerySlide = productWrapper.querySelector('.swiper-wrapper div[data-media-id="'+ mediaId +'"]');
    // console.log(productWrapper, mediaId, gallerySlide);
    if (!gallerySlide) {
      return;
    }
    if ( thumb.matches('[data-media-color="'+ color +'"]') || thumb.getAttribute('data-media-color') === "" ) {
      thumb.style.display = "";
      gallerySlide.style.display = ""
    } else {
      thumb.style.display = "none"
      gallerySlide.style.display = "none"
    }
  });
  window.dispatchEvent(new Event('resize'));

}

window.addEventListener("click", function(evt) {

  // console.log(evt.target.parentElement);

 if (evt.target.matches('.faq__question')) {
   var target = evt.target;
 } else if (evt.target.parentElement.matches('.faq__question')) {
   var target = evt.target.parentElement;
 } else {
   return
 }

 var isOpen = target.getAttribute('aria-expanded') === 'true',
     collapsible = target.parentNode;
     // debugger

 if (isOpen) {
   var toggleButton = collapsible.querySelector('[aria-controls]');

   if (!toggleButton || toggleButton.getAttribute('aria-expanded') === 'false') {
     return; // It's already closed
   }

   var collapsibleContent = collapsible.querySelector("#".concat(toggleButton.getAttribute('aria-controls')));
   toggleButton.setAttribute('aria-expanded', 'false');

   if (toggleButton.hasAttribute('data-collapsible-force-overflow')) {
     collapsibleContent.style.overflow = 'hidden';
   }

   if (collapsibleContent.hasAttribute('aria-hidden')) {
     collapsibleContent.setAttribute('aria-hidden', 'true');
   }

   collapsibleContent.style.height = "";
 } else {
   var toggleButton = collapsible.querySelector('[aria-controls]');

   if (!toggleButton || toggleButton.getAttribute('aria-expanded') === 'true') {
     return; // It's already open
   }

   var collapsibleContent = collapsible.querySelector("#".concat(toggleButton.getAttribute('aria-controls')));
   toggleButton.setAttribute('aria-expanded', 'true');

   if (collapsibleContent.hasAttribute('aria-hidden')) {
     collapsibleContent.setAttribute('aria-hidden', 'false');
   }
   collapsibleContent.style.height = "auto";
 }
}, true);

})();


$(function() {
	$(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
	
	$(".accordion > .accordion-item").click(function() {
		// Cancel the siblings
		$(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
		// Toggle the item
		$(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
	});
});